
import {Component, Vue, Watch} from "vue-property-decorator";
import GelirGiderInfo from "@/components/infos/GelirGiderInfo.vue";
import GiderInfo from "@/components/infos/GiderInfo.vue";
import GelirInfo from "@/components/infos/GelirInfo.vue";
import Dates from "@/components/inputs/Dates.vue";
import {GelirGiderEntity} from "@/entity/GelirGiderEntity";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import OzelAralikDatePicker from "@/components/infos/raporlama-ofispro/helper-comps/OzelAralikDatePicker.vue";
import SayfaAciklama from "@/components/SayfaAciklama.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";

@Component({
  components: {SayfaAciklama, OzelAralikDatePicker, ParaBirimiPicker, Dates, GelirInfo, GiderInfo, GelirGiderInfo}
})
export default class KasaInfo extends Vue {
  isGelirveGider: boolean = localStorage.getItem('kasa-tablo-tercih') ? JSON.parse(localStorage.getItem('kasa-tablo-tercih')??'') : true;  tarihAraligi = {
    baslangicTarihi: '',
    bitisTarihi: ''
  }
  paraBirimi=null;
  oldFilter={
    baslangicTarihi: '',
    bitisTarihi: '',
    paraBirimi: null
  };

  selectedItem = null
  tarihItems = ["Bu Yıl", "Bu Ay", "Bu Hafta"]
  items: Array<GelirGiderEntity> = [];
  gelirItems: Array<GelirGiderEntity> = [];
  giderItems: Array<GelirGiderEntity> = [];
  gelirTotaller: Array<any> = [];
  giderTotaller: Array<any> = [];
  paraBirimleri: Array<any> = [];
  ParaBirimi = ParaBirimi;

  @Watch('isGelirveGider')
    control(){
  }


  selectItem(item:any) {
    if (item === this.selectedItem) {
      return;
    }
    this.selectedItem = item;
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // getMonth() 0-11 aralığında değer döndürür, bu yüzden 1 ekliyoruz.

    if(this.selectedItem === "Bu Yıl"){
      this.tarihAraligi.baslangicTarihi = `${currentYear}-01-01`;
      this.tarihAraligi.bitisTarihi = `${currentYear}-12-31`;
    } else if (this.selectedItem === "Bu Ay") {
      const firstDayOfMonth = new Date(currentYear, currentMonth - 1, 1);
      const lastDayOfMonth = new Date(currentYear, currentMonth, 0);

      this.tarihAraligi.baslangicTarihi = `${currentYear}-${String(currentMonth).padStart(2, '0')}-01`;
      this.tarihAraligi.bitisTarihi = `${currentYear}-${String(currentMonth).padStart(2, '0')}-${lastDayOfMonth.getDate()}`;
    }else if (this.selectedItem === "Bu Hafta") {
      const firstDayOfWeek = new Date(currentDate);
      const lastDayOfWeek = new Date(currentDate);

      // Haftanın ilk gününü belirlemek için
      const dayOfWeek = currentDate.getDay();
      const diffToFirstDay = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
      firstDayOfWeek.setDate(currentDate.getDate() + diffToFirstDay);

      // Haftanın son gününü belirlemek için
      lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

      this.tarihAraligi.baslangicTarihi = firstDayOfWeek.toISOString().substr(0, 10);
      this.tarihAraligi.bitisTarihi = lastDayOfWeek.toISOString().substr(0, 10);
    }


  }
  get netTutarlar() {
    let result: any[] = [];
    
    // Gelir toplamlarını ekle
    (this.gelirTotaller || []).forEach((g: any) => {
      result.push({ para_birimi_id: g.para_birimi_id, gelir: g.gelir_toplam || 0, gider: 0 });
    });
    
    // Gider toplamlarını ekle veya güncelle
    (this.giderTotaller || []).forEach((g: any) => {
      let item = result.find((r: any) => r.para_birimi_id === g.para_birimi_id);
      if (item) {
        item.gider = g.gider_toplam || 0;
      } else {
        result.push({ para_birimi_id: g.para_birimi_id, gelir: 0, gider: g.gider_toplam || 0 });
      }
    });
    
    // Net toplamları hesapla
    return result.map((r: any) => ({ ...r, net_toplam: r.gelir - r.gider }));
  }

  async getParaBirimleri() {
    const response = await this.$helper.requestWithCache("/api/v1/para-birimi-picker");
    const data = response?.data;
    this.paraBirimleri = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  }

  getParaBirimiSembol(paraBirimiId: number) {
    if (paraBirimiId == null) return 'TL';
    if (!Array.isArray(this.paraBirimleri)) return 'TL';
    const paraBirimi: any = this.paraBirimleri.find((p: any) => p.id === paraBirimiId);
    if (!paraBirimi) return 'TL';
    return paraBirimi.id !== this.ParaBirimi.TRY ? paraBirimi.kisa_isim : 'TL';
  }

  async mounted() {
    this.isGelirveGider=false
    this.tarihAraligi.bitisTarihi = new Date().toISOString().substr(0, 10);
    this.tarihAraligi.baslangicTarihi = new Date().toISOString().substr(0, 10).slice(0, -2) + '01';
    if (localStorage.getItem('kasa-tablo-tercih') == null)
      localStorage.setItem('kasa-tablo-tercih', JSON.stringify(this.isGelirveGider));
    await this.getParaBirimleri();
    this.load();
  }

  load(forceLoad:boolean = false) {
    localStorage.setItem('kasa-tablo-tercih', JSON.stringify(this.isGelirveGider));
    if (this.tarihAraligi.baslangicTarihi != this.oldFilter.baslangicTarihi ||
        this.tarihAraligi.bitisTarihi != this.oldFilter.bitisTarihi ||
        this.paraBirimi != this.oldFilter.paraBirimi ||
        forceLoad) {
      if (this.isGelirveGider) {
        this.$http.get('/api/v1/kasa-hareketi/filter', {
          params: {
            baslangicTarihi: this.tarihAraligi.baslangicTarihi,
            bitisTarihi: this.tarihAraligi.bitisTarihi,
            paraBirimi: this.paraBirimi
          }
        }).then((response) => this.items = response.data);
      } else {
        this.$http.get('/api/v1/kasa-hareketi/filter', {
          params: {
            baslangicTarihi: this.tarihAraligi.baslangicTarihi,
            bitisTarihi: this.tarihAraligi.bitisTarihi,
            paraBirimi: this.paraBirimi,
            gelir: 1
          }
        }).then((response) => {
          this.gelirItems = response?.data?.data ?? response?.data ?? [];
          this.gelirTotaller = response?.data?.totaller ?? response?.totaller ?? [];
        });
        this.$http.get('/api/v1/kasa-hareketi/filter', {
          params: {
            baslangicTarihi: this.tarihAraligi.baslangicTarihi,
            bitisTarihi: this.tarihAraligi.bitisTarihi,
            paraBirimi: this.paraBirimi,
            gelir: 0
          }
        }).then((response) => {
          this.giderItems = response?.data?.data ?? response?.data ?? [];
          this.giderTotaller = response?.data?.totaller ?? response?.totaller ?? [];
        });
      }
      this.oldFilter.baslangicTarihi = this.tarihAraligi.baslangicTarihi;
      this.oldFilter.bitisTarihi = this.tarihAraligi.bitisTarihi;
      this.oldFilter.paraBirimi = this.paraBirimi;
    }
  }
}
